(ns app.front.clipboard)

(defn copy-text [text]
  (js/navigator.clipboard.writeText text))
